import LOGO from '../../../../assets/logo/lancape_no_bg.png'
import { FunctionComponent } from 'react'

const Header: FunctionComponent = () => {
  return (
    <div className='bg-white shadow-sm border-b border-gray-200'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between h-16'>
          <div className='flex'>
            <div className='flex-shrink-0 flex items-center'>
              <img className='h-8 w-auto' src={LOGO} alt='Clip' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Header }
